import EmbedWrapper from 'app/home/EmbedWrapper';
import React from 'react';
import { Box } from '@mui/material';
import TileComponent from 'app/home/tile/TileComponent';
import { TileInfo } from 'app/home/index.functions';
import { useMockThumbnailLoader } from 'app/home/useMockThumbnailLoader';

export default function ThemeTilesExample() {
    let thumbnailLoader = useMockThumbnailLoader();
    const timesData: Array<TileInfo> = [
        {
            user_dashboard_element_instance_id: '1',
            user_id: 2,
            element_id: 3,
            segment_value_id: 4,
            section_type: 'Favorite',
            favorite_id: '5',
            category_id: '0',
            element_type: 'external report',
            in_dashboard_ind_flag: 'Y',
            last_stoplight_value: '0',
            is_expired: '1',
            is_owned: '0',
            topics: [],
            refresh_frequency_text: '',
            refresh_frequency_sec: '',
            description_markdown_ind: 'Y',
            element_info: '<p>Daily Sales</p>',
            metric_unit_of_measure: 'compared to last month',
            last_measurement_time: '2023-02-06 00:00:00',
            external_report_download_url_info: '',
            certified_ind: 'N',
            certification_level_id: '0',
            last_certified_time: undefined,
            metric_display_on_tile: 'value',
            metric_moving_average_interval: '',
            metric_display_on_tile_prefix: 'Avg',
            metric_home_page_compare_value_type: 'compare line',
            metric_home_page_compare_line_id: '1',
            metric_home_page_compare_target_id: '',
            report_single_unit_label: '',
            report_multiple_units_label: '',
            report_no_units_label: '',
            report_on_demand_generation_ind: 'Y',
            external_report_display: '',
            certification_level_name: 'Gold',
            certification_level_color: '#ff00ff',
            last_certified_by_name: 'User Name',
            last_certified_by_email: 'user@gmail.com',
            business_owner: 'John Kennedy',
            business_owner_email: 'jk@gmail.com',
            data_steward: 'abby Kennedy',
            data_steward_email: 'bk+abby@metricinsights.com',
            technical_owner: 'John Berg',
            technical_owner_email: 'louis+1@metricinsights.com',
            data_source_name: 'Manual/CSV Data',
            supports_last_refreshed_check: '',
            display_order: 1,
            total_view_count: '30',
            in_favorites: '324,372',
            is_in_favorites: '1',
            is_in_folders: '1',
            mi_name: 'Daily',
            mi_sequence: '30',
            pct_variance_text: 'from Last Week',
            last_measurement_value_formatted: '$30,112',
            last_measurement_time_formatted: 'Monday 06/02/2023',
            metric_last_moving_average_value_formatted: 'C$609,234',
            last_updated_time: '2017-06-22 21:04:19',
            //total_forecast_amount_formatted: '100,000$',
            last_activity_time: '2016-07-21 00:00:00',
            last_annotation_text: 'Anthony Harvey: Had a website outage on 8-10. Ops fixed it and brought it back.',
            last_commentary_text: 'John Berg: Thanks!',
            element_dashboard_name: 'External Report',
            element_dashboard_name_with_formatting: '',
            is_empty_instance_ind: 'N',
            metric_tile_display_pct_variance: -2.2753,
            report_rows: '',
            last_display_generation_time: '2024-11-21 15:19:44',
            last_file_updated_time: '',
            last_modified: 'more_than_month',
            favorite_content: 'custom',
            alert_event_id: '',
            last_alert_text: '',
            last_alert_news_type: '',
            is_alert_active: '0',
            is_collaborative_alert_active: '0',
            is_collaborative_annotation_active: '0',
            is_annotation_active: '0',
            is_commentary_active: '0',
            last_notable_event_activity_time: '2016-07-21 00:00:00',
            last_user_annotation_activity_time: '',
            last_user_note_activity_time: '',
            last_alert_event_activity_time: '',
            reporting_tool_name: 'Tableau',
            remove_preview_link_ind: '',
            is_tech_editor: 'N',
            external_content_type_name: 'Tableau',
            enable_click_in_mobile_ind: '',
            content_type: 'Metric',
            global_total_view_count: 20,
            has_access: 'Y',
        },
        {
            user_dashboard_element_instance_id: '2',
            user_id: 2,
            element_id: 3,
            segment_value_id: 4,
            section_type: 'Favorite',
            favorite_id: '5',
            category_id: '0',
            element_type: 'metric',
            in_dashboard_ind_flag: 'Y',
            last_stoplight_value: '0',
            is_expired: '0',
            is_owned: '0',
            topics: [],
            refresh_frequency_text: '',
            refresh_frequency_sec: '',
            description_markdown_ind: 'Y',
            element_info: '<p>Daily Sales</p>',
            metric_unit_of_measure: 'compared to last month',
            last_measurement_time: '2023-02-06 00:00:00',
            external_report_download_url_info: '',
            certified_ind: 'N',
            certification_level_id: '0',
            last_certified_time: undefined,
            metric_display_on_tile: 'value',
            metric_moving_average_interval: '',
            metric_display_on_tile_prefix: 'Avg',
            metric_home_page_compare_value_type: 'compare line',
            metric_home_page_compare_line_id: '1',
            metric_home_page_compare_target_id: '',
            report_single_unit_label: '',
            report_multiple_units_label: '',
            report_no_units_label: '',
            report_on_demand_generation_ind: 'Y',
            external_report_display: '',
            certification_level_name: 'Gold',
            certification_level_color: '#ff00ff',
            last_certified_by_name: 'User Name',
            last_certified_by_email: 'user@gmail.com',
            business_owner: 'John Kennedy',
            business_owner_email: 'jk@gmail.com',
            data_steward: 'abby Kennedy',
            data_steward_email: 'bk+abby@metricinsights.com',
            technical_owner: 'John Berg',
            technical_owner_email: 'louis+1@metricinsights.com',
            data_source_name: 'Manual/CSV Data',
            supports_last_refreshed_check: '',
            display_order: 1,
            total_view_count: '30',
            in_favorites: '324,372',
            is_in_favorites: '1',
            is_in_folders: '1',
            mi_name: 'Daily',
            mi_sequence: '30',
            pct_variance_text: 'from Last Week',
            last_measurement_value_formatted: '$30,112',
            last_measurement_time_formatted: 'Monday 06/02/2023',
            metric_last_moving_average_value_formatted: 'C$609,234',
            last_updated_time: '2017-06-22 21:04:19',
            //total_forecast_amount_formatted: '100,000$',
            last_activity_time: '2016-07-21 00:00:00',
            last_annotation_text: 'Anthony Harvey: Had a website outage on 8-10. Ops fixed it and brought it back.',
            last_commentary_text: 'John Berg: Thanks!',
            element_dashboard_name: 'Metric are Average',
            element_dashboard_name_with_formatting: '',
            is_empty_instance_ind: 'N',
            metric_tile_display_pct_variance: -2.2753,
            report_rows: '',
            last_display_generation_time: '2024-11-21 15:19:44',
            last_file_updated_time: '',
            last_modified: 'more_than_month',
            favorite_content: 'custom',
            alert_event_id: '',
            last_alert_text: '',
            last_alert_news_type: '',
            is_alert_active: '0',
            is_collaborative_alert_active: '0',
            is_collaborative_annotation_active: '0',
            is_annotation_active: '0',
            is_commentary_active: '0',
            last_notable_event_activity_time: '2016-07-21 00:00:00',
            last_user_annotation_activity_time: '',
            last_user_note_activity_time: '',
            last_alert_event_activity_time: '',
            reporting_tool_name: '',
            remove_preview_link_ind: '',
            is_tech_editor: 'N',
            external_content_type_name: '',
            enable_click_in_mobile_ind: '',
            content_type: 'Metric',
            global_total_view_count: 20,
            has_access: 'Y',
        },
        {
            user_dashboard_element_instance_id: '3',
            user_id: 2,
            element_id: 3,
            segment_value_id: 4,
            section_type: 'Favorite',
            favorite_id: '5',
            category_id: '0',
            element_type: 'metric',
            in_dashboard_ind_flag: 'Y',
            last_stoplight_value: '2',
            is_expired: '0',
            is_owned: '0',
            topics: [],
            refresh_frequency_text: '',
            refresh_frequency_sec: '',
            description_markdown_ind: 'Y',
            element_info: '<p>Daily Sales</p>',
            metric_unit_of_measure: 'compared to last month',
            last_measurement_time: '2023-02-06 00:00:00',
            external_report_download_url_info: '',
            certified_ind: 'N',
            certification_level_id: '0',
            last_certified_time: undefined,
            metric_display_on_tile: 'value',
            metric_moving_average_interval: '',
            metric_display_on_tile_prefix: 'Avg',
            metric_home_page_compare_value_type: 'compare line',
            metric_home_page_compare_line_id: '1',
            metric_home_page_compare_target_id: '',
            report_single_unit_label: '',
            report_multiple_units_label: '',
            report_no_units_label: '',
            report_on_demand_generation_ind: 'Y',
            external_report_display: '',
            certification_level_name: 'Gold',
            certification_level_color: '#ff00ff',
            last_certified_by_name: 'User Name',
            last_certified_by_email: 'user@gmail.com',
            business_owner: 'John Kennedy',
            business_owner_email: 'jk@gmail.com',
            data_steward: 'abby Kennedy',
            data_steward_email: 'bk+abby@metricinsights.com',
            technical_owner: 'John Berg',
            technical_owner_email: 'louis+1@metricinsights.com',
            data_source_name: 'Manual/CSV Data',
            supports_last_refreshed_check: '',
            display_order: 1,
            total_view_count: '30',
            in_favorites: '324,372',
            is_in_favorites: '1',
            is_in_folders: '1',
            mi_name: 'Daily',
            mi_sequence: '30',
            pct_variance_text: 'from Last Week',
            last_measurement_value_formatted: '$169,29',
            last_measurement_time_formatted: 'Monday 06/02/2023',
            metric_last_moving_average_value_formatted: 'C$609,234',
            last_updated_time: '2017-06-22 21:04:19',
            //total_forecast_amount_formatted: '100,000$',
            last_activity_time: '2016-07-21 00:00:00',
            last_annotation_text: 'Anthony Harvey: Had a website outage on 8-10. Ops fixed it and brought it back.',
            last_commentary_text: 'John Berg: Thanks!',
            element_dashboard_name: 'Metric are Neutral',
            element_dashboard_name_with_formatting: '',
            is_empty_instance_ind: 'N',
            metric_tile_display_pct_variance: -8.2753,
            report_rows: '',
            last_display_generation_time: '2024-11-21 15:19:44',
            last_file_updated_time: '',
            last_modified: 'more_than_month',
            favorite_content: 'custom',
            alert_event_id: '',
            last_alert_text: '',
            last_alert_news_type: '',
            is_alert_active: '0',
            is_collaborative_alert_active: '0',
            is_collaborative_annotation_active: '0',
            is_annotation_active: '0',
            is_commentary_active: '0',
            last_notable_event_activity_time: '2016-07-21 00:00:00',
            last_user_annotation_activity_time: '',
            last_user_note_activity_time: '',
            last_alert_event_activity_time: '',
            reporting_tool_name: '',
            remove_preview_link_ind: '',
            is_tech_editor: 'N',
            external_content_type_name: '',
            enable_click_in_mobile_ind: '',
            content_type: 'Metric',
            global_total_view_count: 20,
            has_access: 'Y',
        },
        {
            user_dashboard_element_instance_id: '4',
            user_id: 2,
            element_id: 3,
            segment_value_id: 4,
            section_type: 'Favorite',
            favorite_id: '5',
            category_id: '0',
            element_type: 'metric',
            in_dashboard_ind_flag: 'Y',
            last_stoplight_value: '1',
            is_expired: '0',
            is_owned: '0',
            topics: [],
            refresh_frequency_text: '',
            refresh_frequency_sec: '',
            description_markdown_ind: 'Y',
            element_info: '<p>Daily Sales</p>',
            metric_unit_of_measure: 'compared to last month',
            last_measurement_time: '2023-02-06 00:00:00',
            external_report_download_url_info: '',
            certified_ind: 'N',
            certification_level_id: '0',
            last_certified_time: undefined,
            metric_display_on_tile: 'value',
            metric_moving_average_interval: '',
            metric_display_on_tile_prefix: 'Avg',
            metric_home_page_compare_value_type: 'compare line',
            metric_home_page_compare_line_id: '1',
            metric_home_page_compare_target_id: '',
            report_single_unit_label: '',
            report_multiple_units_label: '',
            report_no_units_label: '',
            report_on_demand_generation_ind: 'Y',
            external_report_display: '',
            certification_level_name: 'Gold',
            certification_level_color: '#ff00ff',
            last_certified_by_name: 'User Name',
            last_certified_by_email: 'user@gmail.com',
            business_owner: 'John Kennedy',
            business_owner_email: 'jk@gmail.com',
            data_steward: 'abby Kennedy',
            data_steward_email: 'bk+abby@metricinsights.com',
            technical_owner: 'John Berg',
            technical_owner_email: 'louis+1@metricinsights.com',
            data_source_name: 'Manual/CSV Data',
            supports_last_refreshed_check: '',
            display_order: 1,
            total_view_count: '30',
            in_favorites: '324,372',
            is_in_favorites: '1',
            is_in_folders: '1',
            mi_name: 'Daily',
            mi_sequence: '30',
            pct_variance_text: 'from Last Week',
            last_measurement_value_formatted: '$100,298',
            last_measurement_time_formatted: 'Monday 06/02/2023',
            metric_last_moving_average_value_formatted: 'C$609,234',
            last_updated_time: '2017-06-22 21:04:19',
            //total_forecast_amount_formatted: '100,000$',
            last_activity_time: '2016-07-21 00:00:00',
            last_annotation_text: 'Anthony Harvey: Had a website outage on 8-10. Ops fixed it and brought it back.',
            last_commentary_text: 'John Berg: Thanks!',
            element_dashboard_name: 'Metric are Good',
            element_dashboard_name_with_formatting: '',
            is_empty_instance_ind: 'N',
            metric_tile_display_pct_variance: 25.2753,
            report_rows: '',
            last_display_generation_time: '2024-11-21 15:19:44',
            last_file_updated_time: '',
            last_modified: 'more_than_month',
            favorite_content: 'custom',
            alert_event_id: '',
            last_alert_text: '',
            last_alert_news_type: '',
            is_alert_active: '0',
            is_collaborative_alert_active: '0',
            is_collaborative_annotation_active: '0',
            is_annotation_active: '0',
            is_commentary_active: '0',
            last_notable_event_activity_time: '2016-07-21 00:00:00',
            last_user_annotation_activity_time: '',
            last_user_note_activity_time: '',
            last_alert_event_activity_time: '',
            reporting_tool_name: '',
            remove_preview_link_ind: '',
            is_tech_editor: 'N',
            external_content_type_name: '',
            enable_click_in_mobile_ind: '',
            content_type: 'Metric',
            global_total_view_count: 20,
            has_access: 'Y',
        },
        {
            user_dashboard_element_instance_id: '5',
            user_id: 2,
            element_id: 3,
            segment_value_id: 4,
            section_type: 'Favorite',
            favorite_id: '5',
            category_id: '0',
            element_type: 'metric',
            in_dashboard_ind_flag: 'Y',
            last_stoplight_value: '3',
            is_expired: '0',
            is_owned: '0',
            topics: [],
            refresh_frequency_text: '',
            refresh_frequency_sec: '',
            description_markdown_ind: 'Y',
            element_info: '<p>Daily Sales</p>',
            metric_unit_of_measure: 'compared to last month',
            last_measurement_time: '2023-02-06 00:00:00',
            external_report_download_url_info: '',
            certified_ind: 'N',
            certification_level_id: '0',
            last_certified_time: undefined,
            metric_display_on_tile: 'value',
            metric_moving_average_interval: '',
            metric_display_on_tile_prefix: 'Avg',
            metric_home_page_compare_value_type: 'compare line',
            metric_home_page_compare_line_id: '1',
            metric_home_page_compare_target_id: '',
            report_single_unit_label: '',
            report_multiple_units_label: '',
            report_no_units_label: '',
            report_on_demand_generation_ind: 'Y',
            external_report_display: '',
            certification_level_name: 'Gold',
            certification_level_color: '#ff00ff',
            last_certified_by_name: 'User Name',
            last_certified_by_email: 'user@gmail.com',
            business_owner: 'John Kennedy',
            business_owner_email: 'jk@gmail.com',
            data_steward: 'abby Kennedy',
            data_steward_email: 'bk+abby@metricinsights.com',
            technical_owner: 'John Berg',
            technical_owner_email: 'louis+1@metricinsights.com',
            data_source_name: 'Manual/CSV Data',
            supports_last_refreshed_check: '',
            display_order: 1,
            total_view_count: '30',
            in_favorites: '324,372',
            is_in_favorites: '1',
            is_in_folders: '1',
            mi_name: 'Daily',
            mi_sequence: '30',
            pct_variance_text: 'from Last Week',
            last_measurement_value_formatted: '$169,298',
            last_measurement_time_formatted: 'Monday 06/02/2023',
            metric_last_moving_average_value_formatted: 'C$609,234',
            last_updated_time: '2017-06-22 21:04:19',
            //total_forecast_amount_formatted: '100,000$',
            last_activity_time: '2016-07-21 00:00:00',
            last_annotation_text: 'Anthony Harvey: Had a website outage on 8-10. Ops fixed it and brought it back.',
            last_commentary_text: 'John Berg: Thanks!',
            element_dashboard_name: 'Metric are Bad',
            element_dashboard_name_with_formatting: '',
            is_empty_instance_ind: 'N',
            metric_tile_display_pct_variance: -8.7553,
            report_rows: '',
            last_display_generation_time: '2024-11-21 15:19:44',
            last_file_updated_time: '',
            last_modified: 'more_than_month',
            favorite_content: 'custom',
            alert_event_id: '',
            last_alert_text: '',
            last_alert_news_type: '',
            is_alert_active: '0',
            is_collaborative_alert_active: '0',
            is_collaborative_annotation_active: '0',
            is_annotation_active: '0',
            is_commentary_active: '0',
            last_notable_event_activity_time: '2016-07-21 00:00:00',
            last_user_annotation_activity_time: '',
            last_user_note_activity_time: '',
            last_alert_event_activity_time: '',
            reporting_tool_name: '',
            remove_preview_link_ind: '',
            is_tech_editor: 'N',
            external_content_type_name: '',
            enable_click_in_mobile_ind: '',
            content_type: 'Metric',
            global_total_view_count: 20,
            has_access: 'Y',
        },
    ];

    return (
        <Box
            sx={{
                marginTop: (theme) => theme.size.pxValue(theme.componentSettings.tile.margin * -1),
                marginLeft: (theme) => theme.size.pxValue(theme.componentSettings.tile.margin * -1),

                '.tile-element': {
                    display: 'inline-flex !important',
                    marginTop: (theme) => theme.size.pxValue(theme.componentSettings.tile.margin),
                    marginLeft: (theme) => theme.size.pxValue(theme.componentSettings.tile.margin),
                },
                '.tile-element__header': {
                    pointerEvents: 'none !important',
                },
            }}
        >
            <EmbedWrapper
                dataParams={{
                    mockData: 'Y',
                }}
                isEmbedded={false}
            >
                {timesData.map((data, index) => (
                    <TileComponent
                        index={index}
                        key={index}
                        moveTile={() => {}}
                        tile={data}
                        section={{
                            title: '',
                            k: '',
                            tiles: [],
                        }}
                        thumbnailLoader={thumbnailLoader}
                        setTile4Favorite={() => {}}
                        customFieldsDisplayOnTileInfo={{}}
                        setTilePreview={() => {}}
                    />
                ))}
            </EmbedWrapper>
        </Box>
    );
}
